import parcelDeliveryUk from './parcel-delivery-uk.json';
import parcelCollection from './parcel-collection.json';
import nextDayDelivery from './next-day-delivery.json';
import weekendDelivery from './weekend-delivery.json';
import saturdayDelivery from './saturday-delivery.json';
import sundayDelivery from './sunday-delivery.json';
import largeParcels from './large-parcels.json';
import heavyParcels from './heavy-parcels.json';
import parcelDeliveryFrance from './parcel-delivery-france.json';
import parcelDeliveryGermany from './parcel-delivery-germany.json';
import parcelDeliveryItaly from './parcel-delivery-italy.json';
import parcelDeliveryNetherlands from './parcel-delivery-netherlands.json';
import parcelDeliverySpain from './parcel-delivery-spain.json';
import parcelDeliveryUSA from './parcel-delivery-usa.json';
import parcelDeliveryIreland from './parcel-delivery-ireland.json';
import parcelDeliveryCanada from './parcel-delivery-canada.json';
import customsAdvice from './customs-advice.json';
import parcelDeliveryNI from './parcel-delivery-northern-ireland.json';
import ioss from './ioss.json';
import international from './international.json';
import packagingTips from './packaging-tips.json';
import parcelDeliveryAustralia from './parcel-delivery-australia.json';
import prohibitedItems from './prohibited-items.json';
import shippingToUsa from './shipping-to-usa.json';

export default {
  'parcel-delivery/uk': parcelDeliveryUk,
  'parcel-collection': parcelCollection,
  'next-day-delivery': nextDayDelivery,
  'weekend-delivery': weekendDelivery,
  'saturday-delivery': saturdayDelivery,
  'sunday-delivery': sundayDelivery,
  'large-parcels': largeParcels,
  'heavy-parcels': heavyParcels,
  'parcel-delivery/france': parcelDeliveryFrance,
  'parcel-delivery/germany': parcelDeliveryGermany,
  'parcel-delivery/italy': parcelDeliveryItaly,
  'parcel-delivery/netherlands': parcelDeliveryNetherlands,
  'parcel-delivery/spain': parcelDeliverySpain,
  'parcel-delivery/usa': parcelDeliveryUSA,
  'parcel-delivery/ireland': parcelDeliveryIreland,
  'parcel-delivery/canada': parcelDeliveryCanada,
  'customs-advice': customsAdvice,
  'parcel-delivery/northern-ireland': parcelDeliveryNI,
  'parcel-delivery/australia': parcelDeliveryAustralia,
  ioss,
  international,
  'packaging-tips': packagingTips,
  'prohibited-items': prohibitedItems,
  'shipping-to-usa': shippingToUsa,
};
